export enum ValidatorEnum {
  EMAIL = 'email',
  MAX = 'max',
  MAX_DECIMAL = 'maxDecimal',
  MAX_LENGTH = 'maxLength',
  MIN = 'min',
  MIN_LENGTH = 'minLength',
  REQUIRED = 'required',
}
